module.exports = __webpack_public_path__ + "img/trophy-02.e5562a8b.svg";